/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { Endpoints, Infer } from 'shared';

import { ApiClient } from '../types/api/ApiClient';
import { ProductPlanTypeResponsePayload } from '../types/product/ProductPlanTypeResponsePayload';
import { getApiEndpoint } from '../utils/getApiEndpoint';
import { apiClientFactory } from '../utils/http-client/apiClientFactory';
import { axiosInstanceFactory } from '../utils/http-client/axiosInstanceFactory';
import { axiosJwtTokenInterceptor, axiosUnauthorizedInterceptor } from '../utils/http-client/axiosInterceptors';

class PlanApiServiceClass {
  private api: ApiClient;

  constructor() {
    this.api = apiClientFactory(
      axiosInstanceFactory(
        { baseURL: getApiEndpoint() },
        [axiosJwtTokenInterceptor],
        [[undefined, axiosUnauthorizedInterceptor]],
      ),
    );
  }

  fetchProductPlans = ({ serviceType }: Infer<typeof Endpoints.GetPlans>['Params']) => {
    return this.api.get<ProductPlanTypeResponsePayload>(Endpoints.GetPlans.route({ serviceType }));
  };
}

export const PlanApiService = new PlanApiServiceClass();
